<template>
  <div style="width:100%;float:left;">
    <CCard v-if="!header">
      <CCardHeader @click="collapsed = !collapsed">Search Order
        <div class="card-header-actions">
          <CLink class="card-header-action btn-minimize">
            <CIcon :name="`cil-chevron-${collapsed ? 'bottom' : 'top'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed" :duration="400">
        <CCardBody>
          <div style="width:100%;float:left;text-align: center;padding-bottom:15px;">
            <!-- <label style="width:100%;text-align:center;color:#ccc;">Press Esc to clear search</label> -->
            <div style="width:320px;text-align:center;margin-left:auto;margin-right:auto;">
              <h5>Search by PO, CC, Log, Cust, Style, Artwork...</h5>
              <input type="search" placeholder="Search..." class="form-control float-left searchInput" @keyup.enter="search()" style="width:250px;" v-model="searchValue" />
              <CButton size="sm" color="info" class="searchButton" @click="search()">Search</CButton>
            </div>
          </div>
          <div style="width:100%;float:left;padding-top:15px;" v-if="data && data.length">
            <label style="width:100%;text-align:center;color:#ccc;">Click row to go to order.</label>
            <table class="table">
              <thead>
                <tr>
                  <th>PO</th>
                  <th>CC</th>
                  <th>Log</th>
                  <th>Cust</th>
                  <!-- <th>Ship To</th> -->
                  <th>Items</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="val in data" style="cursor: pointer;" @click="$router.push('/order/' + val.order_id + '/' + val.order_group_id)">
                  <td>{{val.order.po_number}}</td>
                  <td>{{val.cc_number}}</td>
                  <td>{{val.as400_log_number}}</td>
                  <td>{{val.order.customer_info.customer_name}}</td>
                  <!-- <td>{{val.ship_to_info.ship_name}}</td> -->
                  <td>{{val.order_items_count || 0}}</td>
                  <td>{{val.as400_status}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="width:100%;float:left;text-align:center;" v-if="data && !data.length">
            <label style="width:100%;text-align:center;color:#ccc;">No search results found...</label>
          </div>
        </CCardBody>
      </CCollapse>
    </CCard>
    <div style="width:100%;" class="searchWrapper" v-if="header">
      <CHeaderNavLink>
        <input type="search" placeholder="Search PO, CC, LOG, Cust, Artwork.." class="form-control float-left searchInput" @focus="showOrders = true" @keyup.esc="searchValue = ''" @keyup.enter="search()" style="width:250px;" v-model="searchValue" />
      </CHeaderNavLink>

      <CDropdown 
        placement="bottom-start"
        :caret="false"
        in-nav
        class="c-header-nav-item mt-2"
        add-menu-classes="pt-0 searchMenu"
        :show="showOrders"
        add-toggler-classes="togglerSearch"
        :offset="[0,0]"
        v-if="loading || (data && data.length) || (data && !data.length)"
      >
      <!-- <template #toggler>
        <CHeaderNavLink>
          <CIcon name="cil-chevron-bottom"/>
        </CHeaderNavLink>
      </template> -->

        <div style="width:100%;float:left;margin-top: 10px !important;padding-top:15px;" v-if="loading">
          <div style="width:100%;text-align:center;color:#6c757d;">
            <CSpinner size="sm" color="info" />
            <span style="margin-left:8px;">Searching...</span>
          </div>
        </div>

        <div style="width:100%;float:left;margin-top: 10px !important;padding-top:15px;max-height:500px;overflow-y:scroll;" v-else-if="data && data.length">
          <label style="width:100%;text-align:center;color:#ccc;">Click row to go to order.</label>
          <table class="table">
            <thead>
              <tr>
                <th>PO</th>
                <th>CC</th>
                <th>Log</th>
                <th>Cust</th>
                <!-- <th>Ship To</th> -->
                <th>Items</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="val in data" style="cursor: pointer;" @click="goTo(val)">
                <td>{{val.order.po_number}}</td>
                <td>{{val.cc_number}}</td>
                <td>{{val.as400_log_number}}</td>
                <td>{{val.order.customer_info.customer_name}}</td>
                <!-- <td>{{val.ship_to_info.ship_name}}</td> -->
                <td>{{val.order_items_count || 0}}</td>
                <td>{{val.as400_status}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="width:100%;float:left;margin-top: 10px !important;padding-top:15px;text-align:center;" v-else>
          <label style="width:100%;text-align:center;color:#ccc;">No search results found...</label>
        </div>
      </CDropdown>
    </div>
  </div>
</template>
<script>
var methods = {}

methods.goTo = function (val) {
  // this.showOrders = false
  this.data = null
  this.searchValue = ''
  this.$router.push('/order/' + val.order_id + '/' + val.order_group_id)
}

methods.search = function () {
  if (!this.searchValue) {
    this.data = null
    return
  }
  const postData = {
    searchValue: this.searchValue,
    customer_selected: this.customer_selected
  }
  this.showOrders = false
  this.$nextTick(() => {
    this.showOrders = true
  })
  this.loading = true
  axios.post(this.$apiAdress + '/api/orders/searchPo?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.data = response.data
  }).catch(e => {
    console.log(e)
  }).finally(() => {
    this.loading = false
  })
}

export default {
    // ===Component name
    name: "SearchOrders",
    // ===Props passed to component
    props: ['header', 'customer_selected', 'send_collapsed'],
    // ===Components used by this component
    components: {

    },
    // ====component Data properties
    data(){
        return{
          searchValue: '',
          data: null,
          loading: false,
          showOrders: true,
          collapsed: true
        }
    },
    watch: {
      'searchValue': function (newVal, oldVal) {
        if (this.searchValue === '') {
          this.data = null
        }
      }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      console.log(this.send_collapsed)
      console.log(this.customer_selected)
      if (this.send_collapsed) {
        this.collapsed = false
      }
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style lang="scss">
  .togglerSearch {
    display: none !important;

    &:marker {
        display: none !important; 
    }
}
</style>
